(() => {
  const SIZE_PARAM = 'filter.v.option.size';
  const SIZE_VALUES = [
    '35','35.5','36','36.5','37','37.5','38','38.5','39','39.5',
    '40','40.5','41','41.5','42','42.5','43','43.5','44','44.5',
    '45','45.5','46','46.5','47','47.5','48'
  ];
  const BRANDS = [
    ['Nike', '/collections/nike'],
    ['Adidas', '/collections/adidas'],
    ['New Balance', '/collections/new-balance'],
    ['Jordan', '/collections/jordan'],
    ['ASICS', '/collections/asics'],
    ['Off-White', '/collections/off-white']
  ];

  const language = () => (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
  const translated = (key) => {
    const labels = {
      size: { es:'Talla', fr:'Taille', de:'Größe', it:'Taglia', pt:'Tamanho', en:'Size' },
      brand: { es:'Marca', fr:'Marque', de:'Marke', it:'Marca', pt:'Marca', en:'Brand' },
      collection: { es:'Colección', fr:'Collection', de:'Kollektion', it:'Collezione', pt:'Coleção', en:'Collection' }
    };
    return labels[key][language()] || labels[key].en;
  };
  const selectedSizes = () => new Set(new URL(window.location.href).searchParams.getAll(SIZE_PARAM));

  const checkIcon = `
    <svg width="1.6rem" height="1.6rem" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
      <rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect>
    </svg>
    <svg aria-hidden="true" class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none">
      <path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>`;

  const caretIcon = `
    <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
    </svg>`;

  function removeAvailabilityAndCount(root) {
    root.querySelectorAll('input[name="filter.v.availability"]').forEach((input) => {
      input.closest('details, .mobile-facets__details')?.remove();
    });
    root.querySelectorAll('facet-remove a').forEach((link) => {
      if ((link.getAttribute('href') || '').includes('filter.v.availability')) {
        link.closest('facet-remove')?.remove();
      }
    });
    root.querySelectorAll('.product-count, .product-count-vertical').forEach((count) => count.remove());
  }

  function relabelCollection(root) {
    root.querySelectorAll('input[name="filter.p.product_type"]').forEach((input) => {
      const details = input.closest('details');
      if (!details || details.dataset.arCollectionRelabeled) return;
      details.dataset.arCollectionRelabeled = 'true';
      const label = translated('collection');
      const summaryLabel = details.querySelector('.facets__summary-label, summary span');
      if (summaryLabel) {
        const selected = summaryLabel.querySelector('.facets__selected');
        summaryLabel.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) node.textContent = '';
        });
        summaryLabel.insertBefore(document.createTextNode(label), selected || summaryLabel.firstChild);
      }
      const mobileLabel = details.querySelector('.mobile-facets__summary > div > span:first-child');
      if (mobileLabel) mobileLabel.textContent = label;
      details.querySelector('summary')?.setAttribute('aria-label', label);
    });
  }

  function sizeItems(idPrefix) {
    const selected = selectedSizes();
    return SIZE_VALUES.map((size, index) => `
      <li class="list-menu__item facets__item ar-size-filter__item">
        <label for="${idPrefix}-${index}" class="facets__label facet-checkbox${selected.has(size) ? ' active' : ''}">
          <input type="checkbox" name="${SIZE_PARAM}" value="${size}" id="${idPrefix}-${index}" ${selected.has(size) ? 'checked' : ''}>
          ${checkIcon}
          <span class="facet-checkbox__text" aria-hidden="true">${size}</span>
          <span class="visually-hidden">${size}</span>
        </label>
      </li>`).join('');
  }

  function brandItems() {
    const currentPath = window.location.pathname;
    return BRANDS.map(([name, url]) => `
      <li class="list-menu__item facets__item ar-brand-filter__item">
        <a class="facets__label ar-brand-filter__link${currentPath === url ? ' active' : ''}" href="${url}">${name}</a>
      </li>`).join('');
  }

  function makeDesktopDetails(kind, items) {
    const label = translated(kind);
    const details = document.createElement('details');
    details.className = `disclosure-has-popup facets__disclosure js-filter ar-${kind}-filter`;
    details.dataset.index = `ar-${kind}`;
    details.setAttribute(`data-ar-${kind}-filter`, '');
    details.innerHTML = `
      <summary class="facets__summary caption-large focus-offset" aria-label="${label}">
        <div><span class="facets__summary-label">${label}</span>${caretIcon}</div>
      </summary>
      <div class="parent-display facets__display ar-${kind}-filter__display">
        <fieldset class="facets-wrap parent-wrap">
          <legend class="visually-hidden">${label}</legend>
          <ul class="facets-layout-list facets__list list-unstyled no-js-hidden ar-${kind}-filter__grid" role="list">${items}</ul>
        </fieldset>
      </div>`;
    return details;
  }

  function addDesktopFilters(root) {
    const form = root.querySelector('form.facets__form');
    if (!form) return;
    const details = [...form.querySelectorAll('details.js-filter')];
    const price = details.find((item) => item.querySelector('input[name="filter.v.price.gte"]'));
    const collection = details.find((item) => item.querySelector('input[name="filter.p.product_type"]'));
    if (price && !form.querySelector('[data-ar-size-filter]')) {
      price.before(makeDesktopDetails('size', sizeItems('ArSizeDesktop')));
    }
    if (collection && !form.querySelector('[data-ar-brand-filter]')) {
      collection.before(makeDesktopDetails('brand', brandItems()));
    }
  }

  function makeMobileDetails(kind, items) {
    const label = translated(kind);
    const details = document.createElement('details');
    details.className = `mobile-facets__details js-filter ar-${kind}-filter`;
    details.dataset.index = `mobile-ar-${kind}`;
    details.setAttribute(`data-ar-${kind}-filter`, '');
    details.innerHTML = `
      <summary class="mobile-facets__summary focus-inset">
        <div><span>${label}</span><span class="mobile-facets__arrow">${caretIcon}</span></div>
      </summary>
      <div class="ar-native-filter__mobile-panel">
        <ul class="mobile-facets__list list-unstyled ar-${kind}-filter__grid" role="list">${items}</ul>
      </div>`;
    return details;
  }

  function addMobileFilters(root) {
    const form = root.querySelector('form.mobile-facets__form');
    const content = form?.querySelector('.mobile-facets__main');
    if (!form || !content) return;
    const details = [...content.querySelectorAll('details.mobile-facets__details')];
    const price = details.find((item) => item.querySelector('input[name="filter.v.price.gte"]'));
    const collection = details.find((item) => item.querySelector('input[name="filter.p.product_type"]'));
    if (price && !form.querySelector('[data-ar-size-filter]')) {
      price.before(makeMobileDetails('size', sizeItems('ArSizeMobile')));
    }
    if (collection && !form.querySelector('[data-ar-brand-filter]')) {
      collection.before(makeMobileDetails('brand', brandItems()));
    }
  }

  function enhance() {
    const root = document.getElementById('main-collection-filters');
    if (!root) return;
    removeAvailabilityAndCount(root);
    relabelCollection(root);
    addDesktopFilters(root);
    addMobileFilters(root);
  }

  document.addEventListener('DOMContentLoaded', enhance);
  new MutationObserver(enhance).observe(document.documentElement, { childList: true, subtree: true });
})();